import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class AboutInitiativeApi {
    getConfig() {
        const localStorageKeys = Object.keys(localStorage)
        let token = ''

        if (localStorageKeys.includes('usuario')) {
            token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        } else if (localStorageKeys.includes('authentication-admin')) {
            token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin')).token : ''
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    createAboutInitiative(data) {
        return axios.post(`${URL_API}/cadastro/sobre-organizacao/first`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    getAboutInitiative() {
        return axios.get(`${URL_API}/sobre-organizacao/`, this.getConfig())
    }

    nextAboutInitiative(data) {
        return axios.put(`${URL_API}/cadastro/sobre-organizacao/next`, data, this.getConfig())
    }

    finishAboutInitiative(data) {
        return axios.put(`${URL_API}/cadastro/sobre-organizacao/finish`, data, this.getConfig())
    }

    updateAboutInitiative(data) {
        return axios.put(`${URL_API}/sobre-organizacao/update`, data, this.getConfig())
    }

    getArea() {
        return axios.get(`${URL_API}/sobre-organizacao/area-abrangencia`, this.getConfig())
    }

    getMotivatingAudience() {
        return axios.get(`${URL_API}/sobre-organizacao/publico-motivador`, this.getConfig())
    }

    getBiome() {
        return axios.get(`${URL_API}/sobre-organizacao/bioma`, this.getConfig())
    }

    getDevelopmentStage() {
        return axios.get(`${URL_API}/sobre-organizacao/estagio-desenvolvimento`, this.getConfig())
    }

    getCurrentlyInitiative() {
        return axios.get(`${URL_API}/sobre-organizacao/atualmente-iniciativa`, this.getConfig())
    }

    getCollaboratorNumber() {
        return axios.get(`${URL_API}/sobre-organizacao/numero-colaborador`, this.getConfig())
    }

    getFinancialCategory() {
        return axios.get(`${URL_API}/sobre-organizacao/categoria-financiadora`, this.getConfig())
    }

    getMaturity() {
        return axios.get(`${URL_API}/sobre-organizacao/maturidade`, this.getConfig())
    }

    getEmployeePercentage() {
        return axios.get(`${URL_API}/sobre-organizacao/percentual-colaborador`, this.getConfig())
    }

    getDistrict() {
        return axios.get(`${URL_API}/sobre-organizacao/distrito`, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/about-initiative/AboutInitiativeApi.js